import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ActionButton from 'Common/Buttons/ActionButton';
import Typography from '@material-ui/core/Typography';
import Styles from './ContractChecklist.module.css';

const ContractChecklistView = ({
    checklist,
    handleChange,
    handlePDFChecked,
    allChecked
}) => {
    
    return (
        <div className={Styles.container}>
            <div className={Styles.title}>
			    <Typography variant="h6">Check Contract</Typography>
            </div>
            <FormControl component="fieldset">
                <legend class="sr-only">Check Contract</legend>
                <FormGroup>
                    {checklist.map(item => (
                        <FormControlLabel control={<Checkbox checked={item.isChecked} onChange={handleChange} name={item.name} />} label={item.name} key={item.name} />
                    ))}
                </FormGroup>
            </FormControl>
            <div className={Styles.buttons}>
                <ActionButton text="Checked" onClick={handlePDFChecked} variant="secondary" isDisabled={!allChecked} containerClass={Styles.button} />
            </div>
        </div>
    );
};

ContractChecklistView.propTypes = {
    checklist: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    handlePDFChecked: PropTypes.func.isRequired,
    allChecked: PropTypes.bool.isRequired
};

export default ContractChecklistView;